import {
  resolveRelatedShapeFeatureId,
  syncPersistedSqftShapeFeature,
} from "./syncPersistedSqftShapeFeature";

const getLinkedSQFTIds = (cartItem) => {
  const ids = Array.isArray(cartItem?.sqftIds) ? cartItem.sqftIds : [];
  return cartItem?.sqftId === undefined || cartItem?.sqftId === null
    ? ids
    : [...ids, cartItem.sqftId];
};

// Reconciles every calculator-linked cart item of a quote against its persisted shapes,
// for quotes that have drifted out of sync (cart material differs from the shape's stored feature).
export const syncQuoteSqftCalcDataWithCart = (quotes, quoteIndex, cartItems, layout = null) => {
  const quote = quotes[quoteIndex];
  if (!quote || !Array.isArray(quote.sqFtCalcData?.countertops)) {
    return quotes;
  }

  const linkedCartItems = (cartItems || []).filter(cartItem =>
    Number(cartItem.currentQuote) === Number(quoteIndex) && getLinkedSQFTIds(cartItem).length > 0
  );
  if (linkedCartItems.length === 0) {
    return quotes;
  }

  // One shape can be linked to more than one cart item, such as a cabinet box
  // and its color. Preserve every item so they update their own shape field.
  const desiredFeaturesBySQFTId = new Map();
  linkedCartItems.forEach(cartItem => {
    const featureId = cartItem.cartFeature?.dbFeature?.id;
    if (!featureId) return;
    getLinkedSQFTIds(cartItem).forEach(sqftId => {
      const key = String(sqftId);
      const desiredFeatures = desiredFeaturesBySQFTId.get(key) || [];
      desiredFeatures.push({featureId, partId: cartItem.partId, cartFeature: cartItem.cartFeature});
      desiredFeaturesBySQFTId.set(key, desiredFeatures);
    });
  });
  if (desiredFeaturesBySQFTId.size === 0) {
    return quotes;
  }

  let hasChanges = false;
  const countertops = quote.sqFtCalcData.countertops.map(countertop => {
    const desiredFeatures = desiredFeaturesBySQFTId.get(String(countertop.id));
    if (!desiredFeatures) {
      return countertop;
    }

    const orderedDesiredFeatures = [...desiredFeatures].sort((firstFeature, secondFeature) => (
      Number(firstFeature.partId === countertop.parentPartId)
      - Number(secondFeature.partId === countertop.parentPartId)
    ));
    const updatedCountertop = orderedDesiredFeatures.reduce(
      (currentCountertop, desiredFeature) => syncPersistedSqftShapeFeature(currentCountertop, {
        ...desiredFeature,
        shapeFeatureId: resolveRelatedShapeFeatureId(currentCountertop, desiredFeature.cartFeature, layout),
      }),
      countertop
    );
    hasChanges = hasChanges || updatedCountertop !== countertop;
    return updatedCountertop;
  });

  if (!hasChanges) {
    return quotes;
  }

  const updatedQuotes = [...quotes];
  updatedQuotes[quoteIndex] = {
    ...quote,
    sqFtCalcData: {
      ...quote.sqFtCalcData,
      countertops,
    },
  };
  return updatedQuotes;
};
